export enum AclAssetAccessLevel {
  Title = "Title",
  Content = "Content",
  Asset = "Asset",
}
